import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import { useSeo } from "@/hooks/useSeo";
import { guideFaqs } from "@/mocks/guide";
import GuideSteps from "./components/GuideSteps";
import GuideRules from "./components/GuideRules";

const anchors = [
  { label: "投稿步骤", href: "#steps" },
  { label: "保护身份", href: "#tips" },
  { label: "受理规范", href: "#rules" },
  { label: "细节答疑", href: "#guide-faq" },
];

export default function GuidePage() {
  useSeo({
    title: "爆料指南 | 安全投稿步骤与身份保护建议 - 爆料51",
    description:
      "爆料51爆料指南：详解安全投稿的四个步骤、保护身份的建议清单以及内容受理规范，帮助你在保护隐私的前提下完成匿名投稿与安全爆料。",
    keywords: "爆料指南,匿名投稿步骤,身份保护,安全爆料,爆料51",
    path: "/guide",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://skycv.cn/" },
          { "@type": "ListItem", position: 2, name: "爆料指南", item: "https://skycv.cn/guide" },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "爆料指南 | 安全投稿步骤与身份保护建议 - 爆料51",
        url: "https://skycv.cn/guide",
        description: "安全投稿的四个步骤、身份保护建议与内容受理规范。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: guideFaqs.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: { "@type": "Answer", text: item.answer },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <PageHero
        eyebrow="Anonymous Guide"
        title="爆料指南：把安全放在事实前面"
        subtitle="投稿本身并不难，难的是在说真话的同时不暴露自己。这份指南把该注意的地方拆开讲清楚，你可以按自己的节奏一步步来。"
        crumbs={[{ label: "首页", to: "/" }, { label: "爆料指南" }]}
      />

      <nav aria-label="本页目录" className="bg-background-50 border-b border-background-200 sticky top-16 md:top-20 z-30">
        <div className="w-full px-4 md:px-8">
          <ul className="flex items-center gap-1 overflow-x-auto no-scrollbar py-3">
            {anchors.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className="px-4 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-700 hover:bg-primary-50 transition-colors whitespace-nowrap block"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      <section className="bg-background-50 pt-10 md:pt-14">
        <div className="w-full px-4 md:px-8">
          <div className="w-full h-[220px] md:h-[340px] rounded-lg overflow-hidden border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20dark%20teal%20background%20with%20a%20glowing%20path%20of%20small%20light%20nodes%20leading%20toward%20a%20locked%20gate%20symbol%2C%20encrypted%20grid%20texture%2C%20amber%20accent%20points%2C%20minimal%20modern%20security%20infographic%20aesthetic%2C%20clean%20composition&width=1200&height=700&seq=baoliao51-guide-01&orientation=landscape"
              alt="匿名投稿安全路径示意图，从信息节点通向加密通道"
              title="爆料51安全投稿路径 隐私保护"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      <GuideSteps />
      <GuideRules />

      <section className="bg-background-100 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div className="max-w-2xl">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                准备好了，就从这里开始
              </h2>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
                投稿通道 24 小时开放，不需要注册，也不会记录你的真实身份。
              </p>
            </div>
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-lock-2-line" aria-hidden="true"></i>
              前往匿名投稿
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}